import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import NewsPostCard from "./postCard/NewsPostCard";
import { getLatestPost } from "./firebase";

function NewsSection({ history }) {
  const [latestPost, setLatestPost] = useState(null);

  async function init() {
    let latestPost = await getLatestPost();
    setLatestPost(latestPost);
  }

  useEffect(() => {
    init();
  }, []);

  if (!latestPost) return null;

  return (
    <section className="about-area section-gap text-center ">
      {/* <div className="mb-70"> */}
      <div
        className="container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "400px",
          justifyContent: "spacebetween"
        }}
      >
        <h1>Latest Updates</h1>

        <NewsCard
          post={latestPost}
          key={latestPost.newsKey}
          push={() => history.push(`/news/${latestPost.newsKey}`)}
        />
      </div>
      <Button
        style={{ cursor: "pointer" }}
        onClick={() => history.push(`/news`)}
      >
        All News
      </Button>
      {/* </div> */}
    </section>
  );
}

const Button = styled.button`
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  background: #4b5f78;
  font-family: "Roboto", sans-serif;
  line-height: 42px;
  padding: 0 36px;
  margin-bottom: 10px;
  font-weight: 500;
  border-radius: 10px;
  border: 0px;
`;

const NewsCard = styled(NewsPostCard)`
  &&& {
    margin-top: 30px;
    cursor: pointer;
    max-width: 800px;
  }
`;

export default withRouter(NewsSection);
